import { render } from "./FunnelChart.vue?vue&type=template&id=1ee23610"
import script from "./FunnelChart.vue?vue&type=script&lang=js"
export * from "./FunnelChart.vue?vue&type=script&lang=js"

import "./FunnelChart.vue?vue&type=style&index=0&id=1ee23610&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__